import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14fdb810")

_pushScopeId("data-v-14fdb810")
const _hoisted_1 = { class: "footer-items" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "footer-item" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" © 2021. "),
    /*#__PURE__*/_createVNode("a", {
      class: "heselclinic--link",
      href: "https://hesel.clinic/"
    }, " HESEL Clinic ")
  ])
], -1)
const _hoisted_3 = { class: "footer-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 개인정보처리방침 ")
const _hoisted_5 = { class: "footer-item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 이용약관 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_SelectLanguage = _resolveComponent("SelectLanguage")

  return (_openBlock(), _createBlock("footer", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", null, [
        _createVNode("span", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.RouterName.LEGAL, params: { page: 0 } },
            class: "legal--link"
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.RouterName.LEGAL, params: { page: 1 } },
            class: "legal--link"
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createVNode(_component_SelectLanguage)
    ])
  ]))
})